export const getNumberOfWords = (value?: string): number => value?.match(/\b\S+\b/g)?.length || 0;
